import { Selector } from "./Selector";
import { TextItem } from "./TextItem";
import { MultiTextHead } from "./MultiTextHead";
import { toMap } from "../../../../HA";

export class EditorMultiText extends Selector {

    protected addText(txt: any) {
        if (!this.getList().hasValue(txt) && txt.toString().trim().length > 0) {
            this.getList().addItem(new TextItem(toMap({v: txt, s: true})));
        }
    }

    protected createItem(data: any) {
        return new TextItem(data);
    }

    protected createHead(data?: any) {
        return new MultiTextHead(toMap({
            ed: {
                addText: (txt: any) => {
                    this.addText(txt);
                },
            },
            max: this.get("max"),
        }));
    }
}
